export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_ERROR= "UPDATE_USER_ERROR"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_ERROR = "LOGIN_ERROR"
export const SIGN_OUT = "SIGN_OUT"
export const SIGN_UP = "SIGN_UP"
export const SIGN_OUT_ERROR = "SIGN_OUT_ERROR"
export const SIGN_UP_ERROR = "SIGN_UP_ERROR"
export const ADD_POST = "ADD_POST"
export const ADD_POST_ERROR = "ADD_POST_ERROR"
export const DELETE_POST = "DELETE_POST"
export const EDIT_POST = "EDIT_POST"
export const EDIT_POST_ERROR = "EDIT_POST_ERROR"
export const POST_CATEGORIES = "POST_CATEGORIES"
export const SEND_ENQUIRY = "SEND_ENQUIRY"
export const POST_CLICK = "POST_CLICK"